import { render, staticRenderFns } from "./WatchProduct.vue?vue&type=template&id=5f8d56ec&scoped=true"
import script from "./WatchProduct.vue?vue&type=script&lang=js"
export * from "./WatchProduct.vue?vue&type=script&lang=js"
import style0 from "./WatchProduct.vue?vue&type=style&index=0&id=5f8d56ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8d56ec",
  null
  
)

export default component.exports